module.exports = __webpack_public_path__ + "static/media/home-fc-gator.a3a6709a.svg";